// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 't__plugin-layout__Layout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/.umi-production/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/index.html",
        "redirect": "/overview",
        "exact": true
      },
      {
        "path": "/",
        "redirect": "/overview",
        "exact": true
      },
      {
        "name": "overview",
        "path": "/overview",
        "icon": "icon-gailan",
        "exact": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "access": "overview",
        "routes": [
          {
            "path": "/overview",
            "redirect": "/overview/consumption",
            "exact": true
          },
          {
            "name": "consumption_overview",
            "path": "/overview/consumption",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Overview__ConsumptionOverview' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Overview/ConsumptionOverview'), loading: LoadingComponent}),
            "access": "overview",
            "exact": true
          },
          {
            "name": "media_consumption_overview",
            "path": "/overview/media",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Overview__MediaConsumption' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Overview/MediaConsumption'), loading: LoadingComponent}),
            "access": "overview",
            "exact": true
          }
        ]
      },
      {
        "name": "user",
        "path": "/user",
        "layout": false,
        "exact": false,
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__UserLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/user",
            "redirect": "/user/login",
            "exact": true
          },
          {
            "name": "login",
            "path": "/user/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Login' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Administration/Login'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "register",
            "path": "/user/register",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Register' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Administration/Register'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "active",
            "path": "/user/active",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Active' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Administration/Active'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "forget",
            "path": "/user/forget",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Forget' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Administration/Forget'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "reset",
            "path": "/user/reset",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Reset' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Administration/Reset'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "account_opening_management",
        "path": "/account-apply",
        "icon": "icon-kaihuguanli",
        "exact": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/account-apply",
            "redirect": "/account-apply/apply",
            "exact": true
          },
          {
            "name": "account_open_apply",
            "path": "/account-apply/apply",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountApply__Apply' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AccountApply/Apply'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "opening_record",
            "path": "/account-apply/account-opening-record",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountApply__AccountOpeningRecord' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AccountApply/AccountOpeningRecord'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "detail",
            "path": "/account-apply/detail/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountApply__AccountOpeningRecord__Detail' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AccountApply/AccountOpeningRecord/Detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "other_media_apply",
            "path": "/account-apply/other-media-apply",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OpenAccounts__OtherMedia__Apply' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/OpenAccounts/OtherMedia/Apply'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "name": "wallet",
        "path": "/wallet",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Wallet'), loading: LoadingComponent}),
        "icon": "icon-a-bianzubeifen3",
        "access": "hasWallet",
        "exact": true
      },
      {
        "name": "walletRecord",
        "path": "/wallet/record",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__modules__TransactionRecords' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Wallet/modules/TransactionRecords'), loading: LoadingComponent}),
        "hideInMenu": true,
        "access": "hasWallet",
        "routes": [
          {
            "path": "/wallet/record",
            "redirect": "/wallet/record/transaction",
            "exact": true
          },
          {
            "name": "transaction",
            "path": "/wallet/record/transaction",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__modules__TransactionRecords__Tabs__Transaction' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Wallet/modules/TransactionRecords/Tabs/Transaction'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "order",
            "path": "/wallet/record/order",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__modules__TransactionRecords__Tabs__Order' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Wallet/modules/TransactionRecords/Tabs/Order'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "quota_management",
        "path": "/credit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Credit' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Credit'), loading: LoadingComponent}),
        "icon": "icon-eduguanli",
        "access": "hasCredit"
      },
      {
        "name": "advertising_guidance",
        "path": "/advertising-guidance",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AdvertisingGuidance' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AdvertisingGuidance'), loading: LoadingComponent}),
        "icon": "icon-a-bianzubeifen3",
        "access": "isAdvertisingGuidance",
        "exact": true
      },
      {
        "name": "advertising_guidance",
        "path": "/advertising-guidance",
        "exact": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "hideInMenu": true,
        "access": "isAdvertisingGuidance",
        "routes": [
          {
            "name": "advertising_guidance_detail",
            "path": "/advertising-guidance/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AdvertisingGuidance__detail' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AdvertisingGuidance/detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "access": "isAdvertisingGuidance",
            "exact": true
          }
        ]
      },
      {
        "name": "quota_change_record",
        "path": "/credit/record",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Credit__Record' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Credit/Record'), loading: LoadingComponent}),
        "access": "hasCredit",
        "hideInMenu": true,
        "exact": true
      },
      {
        "name": "transactions_record",
        "path": "/credit/transactions",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Credit__Transactions' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Credit/Transactions'), loading: LoadingComponent}),
        "access": "hasCredit",
        "hideInMenu": true,
        "routes": [
          {
            "path": "/credit/transactions",
            "redirect": "/credit/transactions/transaction",
            "exact": true
          },
          {
            "name": "transaction",
            "path": "/credit/transactions/transaction",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Credit__Transactions__Tabs__Transaction' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Credit/Transactions/Tabs/Transaction'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "order",
            "path": "/credit/transactions/order",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Credit__Transactions__Tabs__Order' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Credit/Transactions/Tabs/Order'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "account_management",
        "path": "/account-manage",
        "icon": "icon-guanggaozhanghuguanli",
        "exact": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "access": "notMh",
        "routes": [
          {
            "name": "openai_needs",
            "path": "/account-manage/openai",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Openai' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Openai'), loading: LoadingComponent}),
            "access": "openaiNeeds",
            "exact": true
          },
          {
            "name": "facebook_needs",
            "path": "/account-manage/facebook",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Facebook' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Facebook'), loading: LoadingComponent}),
            "access": "facebookNeeds",
            "exact": true
          },
          {
            "name": "google_needs",
            "path": "/account-manage/google",
            "access": "isNonPrepayConsume",
            "routes": [
              {
                "path": "/account-manage/google",
                "redirect": "/account-manage/google/list",
                "exact": true
              },
              {
                "name": "google_needs",
                "path": "/account-manage/google/list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Google' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Google'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "detail",
                "path": "/account-manage/google/detail/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Google__Detail' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Google/Detail'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "tiktok_needs",
            "path": "/account-manage/tiktok",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Tiktok' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Tiktok'), loading: LoadingComponent}),
            "access": "isNonPrepayConsumeTiktok",
            "exact": true
          },
          {
            "name": "tiktok_sea_needs",
            "path": "/account-manage/tiktok_sea",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__TiktokSEA' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/TiktokSEA'), loading: LoadingComponent}),
            "access": "isNonPrepayConsume",
            "exact": true
          },
          {
            "name": "cid_management",
            "path": "/account-manage/cid",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Microsoft__CID' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Microsoft/CID'), loading: LoadingComponent}),
            "access": "isNonPrepayConsumeCID",
            "exact": true
          },
          {
            "name": "other_media_account_management",
            "path": "/account-manage/other_media_account",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__OtherMediaAccount' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/OtherMediaAccount'), loading: LoadingComponent}),
            "access": "isEmergingMediaAiAssist",
            "exact": true
          },
          {
            "name": "other_media_needs",
            "path": "/account-manage/other",
            "access": "isNonPrepayConsumeOtherMediaNeeds",
            "routes": [
              {
                "path": "/account-manage/other",
                "redirect": "/account-manage/other/list",
                "exact": true
              },
              {
                "name": "other_media_needs",
                "path": "/account-manage/other/list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__OtherMedia' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/OtherMedia'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "detail",
                "path": "/account-manage/other/detail/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__OtherMedia__Detail' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/OtherMedia/Detail'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "demand_application_record",
            "path": "/account-manage/application",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/account-manage/application",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountApply__ApplicationRedirect' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AccountApply/ApplicationRedirect'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "facebook",
                "path": "/account-manage/application/facebook",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Application__Facebook' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Application/Facebook'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "google",
                "path": "/account-manage/application/google",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Application__Google' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Application/Google'), loading: LoadingComponent}),
                "hideInMenu": true,
                "access": "isNonPrepayConsume",
                "exact": true
              },
              {
                "name": "tiktok",
                "path": "/account-manage/application/tiktok",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Application__Tiktok' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Application/Tiktok'), loading: LoadingComponent}),
                "hideInMenu": true,
                "access": "isNonPrepayConsumeTiktok",
                "exact": true
              },
              {
                "name": "tiktok_sea",
                "path": "/account-manage/application/tiktok_sea",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Accounts__Application__TiktokSEA' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Accounts/Application/TiktokSEA'), loading: LoadingComponent}),
                "hideInMenu": true,
                "access": "isNonPrepayConsume",
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "name": "monitoring_and_warning",
        "path": "/monitoring",
        "exact": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "icon": "icon-data-screen",
        "access": "monitoringMenu",
        "routes": [
          {
            "name": "anti_theft_brush_monitoring",
            "path": "/monitoring/brush_monitoring",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BrushMonitoring' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/BrushMonitoring'), loading: LoadingComponent}),
            "access": "customerBrushMonitoring",
            "exact": true
          },
          {
            "name": "consumption_warning",
            "path": "/monitoring/consumption-warning",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ConsumptionWarning' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/ConsumptionWarning'), loading: LoadingComponent}),
            "access": "customerConsumptionConfigured",
            "exact": true
          },
          {
            "hideInMenu": true,
            "path": "/monitoring/brush_monitoring/running_log",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BrushMonitoring__RunningLog' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/BrushMonitoring/RunningLog'), loading: LoadingComponent}),
            "access": "customerBrushMonitoring",
            "exact": true
          }
        ]
      },
      {
        "name": "toolkit",
        "path": "/toolkit",
        "icon": "icon-chuhaigongju",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Toolkit' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Toolkit'), loading: LoadingComponent})
      },
      {
        "name": "currency_exchange_rate",
        "path": "/toolkit/currency_exchange_rate",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Toolkit__CurrencyExchangeRate' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Toolkit/CurrencyExchangeRate'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "name": "amazon_marketing",
        "path": "/amazon",
        "exact": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "icon": "icon-amazon",
        "routes": [
          {
            "name": "amazon_data_overview",
            "path": "/amazon/amazon_data_overview",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AmazonMarketing__AmazonDataOverview' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AmazonMarketing/AmazonDataOverview'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "tag_management",
            "path": "/amazon/tag_management",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AmazonMarketing__TagManagement' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/AmazonMarketing/TagManagement'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "manage_config",
        "path": "/manage-config",
        "exact": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "icon": "SettingOutlined",
        "routes": [
          {
            "name": "team_management",
            "path": "/manage-config/team-manage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TeamManage' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/TeamManage'), loading: LoadingComponent}),
            "access": "teamManageMenu",
            "exact": true
          },
          {
            "name": "team_member_details",
            "path": "/manage-config/team-manage/member/:team_id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TeamManage__TeamMemberDetail' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/TeamManage/TeamMemberDetail'), loading: LoadingComponent}),
            "access": "teamManageMenu",
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "advertising_account_details",
            "path": "/manage-config/team-manage/account/:team_id/:platform?",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TeamManage__AccountManageDetail' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/TeamManage/AccountManageDetail'), loading: LoadingComponent}),
            "access": "teamManageMenu",
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "personnel_management",
            "path": "/manage-config/personnel-manage_new",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PersonnelManageNew' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/PersonnelManageNew'), loading: LoadingComponent}),
            "access": "personnelManageNew",
            "exact": true
          },
          {
            "name": "personnel_management",
            "path": "/manage-config/personnel-manage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PersonnelManage' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/PersonnelManage'), loading: LoadingComponent}),
            "access": "personnelManage",
            "exact": true
          }
        ]
      },
      {
        "path": "/consumption-warning",
        "redirect": "/monitoring/consumption-warning",
        "exact": true
      },
      {
        "name": "prepay_consume_menu",
        "path": "/consumption",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PrepayConsume' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/PrepayConsume'), loading: LoadingComponent}),
        "icon": "icon-yufushixiao",
        "access": "isPrepayConsume"
      },
      {
        "name": "info",
        "path": "/info",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__UserInfo' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/Administration/UserInfo'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "name": "authResult",
        "path": "/auth-result-page",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__UserManage__Auth__Result' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/UserManage/Auth/Result'), loading: LoadingComponent}),
        "hideInMenu": true,
        "parentKeys": [
          "/user-manage/auth"
        ],
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/bv_vl_web/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
